import { SVGIconComponent } from './types';

export const ProjectTypeBusiness: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/business" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M2.08954427,4.51834646 L4.38175292,4.51834646 L4.38175292,7.9044841 C4.38175292,9.43134123 6.74153133,9.43134123 6.74153133,7.9044841 L6.74153133,4.51834646 L11.2583789,4.51834646 L11.2583789,7.9044841 C11.2583789,9.43134123 13.6181573,9.43134123 13.6181573,7.9044841 L13.6181573,4.51834646 L15.9103659,4.51834646 C17.0564703,4.51834646 18,5.44758876 18,6.57633816 L18,13.8789963 L0.000853040139,13.8789963 L0.000853040139,6.57633816 C0.000853040139,5.44758876 0.944382781,4.51834646 2.09048711,4.51834646 L2.08954427,4.51834646 Z M11.8642619,7.9044841 C11.8642619,8.70160602 13.0103662,8.70160602 13.0103662,7.9044841 L13.0103662,2.59335949 C13.0103662,1.73061955 12.336038,1 11.3925082,1 L6.60650406,1 C5.73049918,1 4.98864609,1.73061955 4.98864609,2.59335949 L4.98864609,7.9044841 C4.98864609,8.70160602 6.20225282,8.70160602 6.20225282,7.9044841 L6.20225282,2.59335949 C6.20225282,2.32737215 6.33729357,2.12872729 6.60650406,2.12872729 L11.3925082,2.12872729 C11.6625852,2.12872729 11.8642843,2.32822111 11.8642843,2.59335949 L11.8642619,7.9044841 Z M17.9989674,14.8755148 L17.9989674,15.0085107 C17.9989674,16.1372601 17.0554376,17 15.9093333,17 L2.08963407,17 C0.94352974,17 0,16.1372601 0,15.0085107 L0,14.8755148 L17.9989674,14.8755148 Z"
        id="Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
